import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../services/auth';

export default function TourStart() {
  const navigate = useNavigate();

  useEffect(() => {
    const role = AuthService.getCurrentUserRole();
    let targetRoute = '/login';

    if (role === 'habitante') {
      targetRoute = '/residenthub';
    } else if (role === 'receptor') {
      targetRoute = '/recepcion';
    } else if (role === 'admin' || role === 'superuser') {
      targetRoute = '/adminhub';
    }

    // Navigate to respective dashboard
    navigate(targetRoute, { replace: true });

    // Trigger the tour slightly after navigation
    setTimeout(() => {
      window.dispatchEvent(new Event('mgo:start-tour'));
    }, 500); // Wait enough time for the routes and navbar to settle
  }, [navigate]);

  return null;
}
